import ModelService from "./abstract/ModelService";
import User from "../models/User";

export default class UserService extends ModelService {
  constructor() {
    super('/users', User);
  }

  updatePreference(model) {
    return new Promise((resolve, reject) => {
      this.put(config.app.api_url + this.modelPath + '/' + model.user_id + '/preference', this.modelName ? { [this.modelName]: model } : model).then(data => {

        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  setInactive(model_id) {
    return new Promise((resolve, reject) => {
      this.put(config.app.api_url + this.modelPath + '/' + model_id + '/set-inactive').then(data => {

        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  fetchUser() {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + this.modelPath + '/find-by-token').then((data) => {
        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  forgotPassword(model) {
    return new Promise((resolve, reject) => {
      this.post(config.app.api_url + '/password/email', {
        email: model.user.username
      }).then(data => {
        resolve(data);
      }).catch((e) => reject(e.response));
    });
  }

  resetPassword(model) {
    return new Promise((resolve, reject) => {
      this.post(config.app.api_url + '/password/reset', model)
      .then(data => {
        resolve(data);
      }).catch((e) => reject(e.response));
    });
  }
}
